import { FormattedMessage } from 'react-intl';

import { Button, TextButton } from '@xing-com/button';
import { Headline, BodyCopy } from '@xing-com/typography';

import { useDeckCardTyped } from '../../context';

import { Container } from './error-card.styled';

export const ErrorCard: React.FC = () => {
  const { data } = useDeckCardTyped(['Error']);

  return (
    <Container>
      <Headline size="xxlarge">
        <FormattedMessage id={data.headerKey} />
      </Headline>
      <BodyCopy size="small">
        <FormattedMessage id={data.descriptionKey} />
      </BodyCopy>
      {data.mainButton ? (
        <Button
          variant="onColor"
          size="medium"
          onClick={data.mainButton.onClick}
        >
          <FormattedMessage id={data.mainButton.labelKey} />
        </Button>
      ) : null}
      {data.secondaryButton ? (
        <TextButton size="medium" onClick={data.secondaryButton.onClick}>
          <FormattedMessage id={data.secondaryButton.labelKey} />
        </TextButton>
      ) : null}
    </Container>
  );
};
